export const GET_CATALOGUES = 'getCatalogues'
export const CREATE_CATALOGUE = 'createCatalogue'
export const UPDATE_CATALOGUE = 'updateCatalogue'
export const DELETE_CATALOGUE = 'deleteCatalogue'